import React from 'react';
import { richText } from '../../util/richText';

import { Card } from '../../components/Card/Card';
import css from './ListingPageDescription.module.css';
import { FormattedMessage } from 'react-intl';
import OrganizationField from './CustomFields/OrganizatioNameField';
import { SocialMediaField } from './CustomFields/SocialMediaField';

const MIN_LENGTH_FOR_LONG_WORDS = 20;

const SectionTextMaybe = props => {
  const { currentListing } = props;
  const {
    attributes: {
      description,
      publicData: { organization_name, website, linkedin, facebook, instagram, tiktok, youtube },
    },
  } = currentListing || {
    attributes: {
      description: '',
      publicData: {
        organization_name: '',
        website: '',
        linkedin: '',
        facebook: '',
        instagram: '',
        tiktok: '',
        youtube: '',
      },
    },
  };
  const content = richText(description, {
    linkify: true,
    longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
    longWordClass: css.longWord,
    breakChars: '/',
  });
  const isEmpty = value => value === '' || value === null || value === undefined;
  const isOrganizationName = !isEmpty(organization_name);
  const isWebsite = !isEmpty(website);
  const isLinkedin = !isEmpty(linkedin);
  const isFacebook = !isEmpty(facebook);
  const isInstagram = !isEmpty(instagram);
  const isTiktok = !isEmpty(tiktok);
  const isYoutube = !isEmpty(youtube);

  const isAllEmpty =
    isEmpty(organization_name) &&
    isEmpty(website) &&
    isEmpty(linkedin) &&
    isEmpty(facebook) &&
    isEmpty(instagram) &&
    isEmpty(tiktok) &&
    isEmpty(youtube);

  return description ? (
    <Card>
      <div className={css.descriptionWrapper}>
        <div className={css.descriptionHeader}>
          <Icon />
          <FormattedMessage id="Cappa.sectionTitleDescription" defaultMessage="Description" />
        </div>

        <p className={css.descriptionText}>{content}</p>

        {!isAllEmpty && (
          <>
            <div className={css.descriptionFooter}>
              <FormattedMessage
                id="EditListingDetailsForm.additionalFields"
                defaultMessage="Additional informations"
              />
            </div>
            <div className={css.descriptionFooterContent}>
              {isOrganizationName && <OrganizationField text={organization_name} />}
              {isWebsite && <SocialMediaField url={website} type={'WEBSITE'} />}
              {isLinkedin && <SocialMediaField url={linkedin} type={'LINKEDIN'} />}
              {isFacebook && <SocialMediaField url={facebook} type={'FACEBOOK'} />}
              {isInstagram && <SocialMediaField url={instagram} type={'INSTAGRAM'} />}
              {isTiktok && <SocialMediaField url={tiktok} type={'TIKTOK'} />}
              {isYoutube && <SocialMediaField url={youtube} type={'YOUTUBE'} />}
            </div>{' '}
          </>
        )}
      </div>
    </Card>
  ) : null;
};

const Icon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 6.7V20C20 21.1 19.06 22 17.9 22H6.1C4.95 22 4 21.1 4 20V4C4 2.9 4.94 2 6.1 2H14.82"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.0003 6.7L14.8203 2"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.46094 13.5195H16.2909"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.46094 16.6504H11.8709"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.46094 10.4004H16.2909"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SectionTextMaybe;
